import Alert from '@ancon/wildcat-ui/web/orderweb/Alert'
import '@ancon/wildcat-ui/web/orderweb/Alert/Alert.css'

export default Alert
